import { Box, Flex, Heading, LinkBox, LinkOverlay, Text } from "@chakra-ui/react"
import { ImageModel } from "../../../../api-clients/product-api-v1"
import { useBrandedTranslation } from "../../../../common/hooks/useBrandedTranslation"
import CustomImage from "../../../shared/CustomImage"
import CustomLink from "../../../shared/CustomLink"
import { CArrowRight } from "../../../shared/Icons"

type Props = {
  headline: string
  description: string
  link: string
  image: ImageModel
}

export const SeriesOverviewCard = ({ headline, description, link, image }: Props) => {
  const { t } = useBrandedTranslation()

  const fallbackImgSrc = "/images/placeholder-image.svg"
  const imgSrcSet = !!image?.key
    ? `${image.large} 1x, ${image.medium} 2x, ${image.small} 3x`
    : `${fallbackImgSrc} 1x, ${fallbackImgSrc} 2x, ${fallbackImgSrc} 3x`

  return (
    <LinkBox maxW="98" width="100%" margin="auto">
      <Flex
        direction="column"
        overflow="hidden"
        outline="solid 1px"
        outlineColor="gray.350"
        cursor="pointer"
        _hover={{ img: { transform: "scale(1.2)" }, outlineColor: "gray.500" }}
        _active={{ outlineColor: "gray.900" }}
      >
        <Box overflow="hidden">
          <CustomImage
            style={{ transition: "transform 250ms ease" }}
            srcSet={imgSrcSet}
            alt={`Concept bathroom design, made using the ${headline} serie products.`}
            width={{ base: "100%", xs: "98" }}
            height={{ base: "auto", xs: "55" }}
            maxHeight="55"
            loading="eager"
          />
        </Box>

        <Box p="6" pb="4">
          <Heading lineHeight={1.25} fontSize={{ base: "xl", sm: "2xl", md: "3xl" }} noOfLines={1}>
            {headline}
          </Heading>

          <Text mt="3" color="gray.800" height="12" noOfLines={2}>
            {description}
          </Text>
        </Box>

        <Flex minH="18" px="6" pb="6" alignItems="flex-end" justifyContent="flex-end">
          <CustomLink href={link}>
            <LinkOverlay _hover={{ textDecoration: "underline", textDecorationColor: "brand.500" }}>
              <Text textAlign="end" fontWeight="medium" color="brand.500" noOfLines={2}>
                <CArrowRight color="brand.500" mr="2" mt="-0.5" />
                {t("series-tile-view-now-link", { seriesName: headline })}
              </Text>
            </LinkOverlay>
          </CustomLink>
        </Flex>
      </Flex>
    </LinkBox>
  )
}
